// extracted by mini-css-extract-plugin
module.exports = {"svg":"DropdownButton_svg__f4DZe","svgWrap":"DropdownButton_svgWrap__2TCF7","icon":"DropdownButton_icon__foRoa"};